import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var BellIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M12 2c4.18 0 8 3.62 8 6v7.816c.047.06.117.136.207.227.294.294.76.683 1.393 1.157l.025.02a1 1 0 01-.509 1.774L21 19h-6a3 3 0 01-5.995.176L9 19H3a1 1 0 01-.601-1.8c.633-.474 1.1-.863 1.394-1.157.09-.09.16-.168.207-.227V8c0-2.38 3.82-6 8-6zm1 17h-2a1 1 0 001.993.117L13 19zM12 4c-1.742 0-3.275.69-4.5 1.851C6.622 6.683 6 7.735 6 8v8c0 .335-.121.654-.38 1h12.76c-.259-.346-.38-.665-.38-1V8c0-.265-.622-1.317-1.5-2.149C15.275 4.691 13.742 4 12 4z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
BellIcon.isCarinaIcon = true;
export default BellIcon;
